import { fetchGet } from "../util/apiUtil";

export const loadPlayers = () => fetchGet("Players/GetAll");
export const loadPlayerDetails = (playerId: number) =>
  fetchGet("Players/GetDetails", { playerId });
